export const DocumentStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  MISSING: "MISSING",
  EXPIRED: "EXPIRED",
};

export const DOCUMENT_STATUS_METADATA = {
  APPROVED: {
    color: "blue",
    content: "approved",
    order: 2,
  },
  REJECTED: {
    color: "red",
    content: "rejected",
    order: 3,
  },
  PENDING: {
    color: "gold",
    content: "in review",
    order: 1,
  },
};

export const MISCELLANEOUS = "miscellaneous";

export const MISCELLANEOUS_APPROVAL_WARNING_MESSAGE =
  "Cannot approve Miscellaneous documents. Please change the Category/Requirement to the correct document type first.";

export const MISSING_REQUIREMENT_WARNING_MESSAGE = "Please select a Category/Requirement.";

export enum RequirementMappingLevel {
  GLOBAL = "GLOBAL",
  STATE = "STATE",
  COUNTY = "COUNTY",
  MSA = "MSA",
  HCF = "HCF",
}
